<template>
	<div 	class="position-absolute word-wrapper"
				:class="visible ? 'pulse-animation scale transition-delay-'+delay+'' : 'invisible-transition scale'"
				:style="{ top: posTop, left: posLeft, right: posRight, bottom: posBottom }">
		<span :class="'font-weight-'+fontWeight+' '+fontSize+''">{{ word }}</span>
	</div>
</template>

<script>
	export default {
		props: {
	    visible: {
        default: () => false
	    },
	    delay: {
        default: () => 0
	    },
	    word: {
        default: () => ''
	    },
	    posTop: {
        default: () => 'auto'
	    },
	    posLeft: {
        default: () => 'auto'
	    },
	    posRight: {
        default: () => 'auto'
	    },
	    posBottom: {
        default: () => 'auto'
	    },
	    fontWeight: {
        default: () => 'regular'
	    },
	    fontSize: {
        default: () => 'medium'
	    }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Word.vue